import * as angular from "angular";
import { EffortDataProvider } from "../../data-provider/effort.dp";
import { Effort } from "../../models/effort.model";
import { ResultDataProvider } from "../../data-provider/result.dp";
import { DashboardWidget } from "../../models/dashboard-widget.model";
import { CanvassStatus } from "../../models/canvass-status.model";
import { CanvassStatusDataProvider } from "../../data-provider/canvass-status.dp";
import { DashboardWidgetFilter } from "../../models/dashboard-widget-filter.model";
import {
    NEW_CONTACTS_TOOLTIP,
    isNewContactsMetric,
    newContactsLabels,
} from "../dashboard/widget/new-contacts-metrics";

let DataStatsComponent = {
    selector: "vcDataStats",
    templateUrl: "/angular/components/result/data-stats.component.html",
    bindings: {
        widget: "=",
        filter: "=",
    },
    controller: class DataStatsController {
        // * bindings for typescript compiler *
        public widget: DashboardWidget;
        public filter: DashboardWidgetFilter;
        // ************************************

        public loading = true;
        public labels: any;
        public canvassStatuses: CanvassStatus[];
        public data: any;
        public dataProvider: ResultDataProvider;
        public effortDataProvider: EffortDataProvider;
        public effort: Effort;
        public options;
        public readonly newContactsTooltip: string = NEW_CONTACTS_TOOLTIP;
        public readonly isNewContactsMetric: (key: string) => boolean = isNewContactsMetric;

        constructor(
            $scope: any,
            $timeout: any,
            __env: any,
            CanvassStatusDataProvider: CanvassStatusDataProvider,
            EffortDataProvider: EffortDataProvider,
            ResultDataProvider: ResultDataProvider
        ) {
            this.dataProvider = ResultDataProvider;
            this.effortDataProvider = EffortDataProvider;

            this.labels = {
                interactions: "Interactions",
                doors_knocked: "Doors Knocked",
                avg_rating: "Avg. Rating",
                conversion_rate: "Conversion Rate",
                conversion_numerator_units: "Conversions",
                conversion_denominator_units: "Counted Attempts",
                contacts: "Contacts Created",
                houses: "Houses Created",
                issues: "Follow-up Requests",
                contacts_surveyed: "Contacts Surveyed",
                interaction_status_7: "Answered (Go App)",
                interaction_status_8: "Not Interested (Go App)",
            };

            CanvassStatusDataProvider.walkCanvassStatuses().then((statuses) => {
                this.canvassStatuses = statuses;

                angular.forEach(
                    this.canvassStatuses,
                    (status: CanvassStatus) => {
                        this.labels["interaction_status_" + status.id] =
                            status.name;
                    }
                );

                angular.extend(this.labels, newContactsLabels(this.canvassStatuses, true));
            });

            $scope.$watch(
                () => this.widget,
                (newValue, oldValue) => {
                    if (oldValue && newValue !== oldValue) {
                        if (
                            oldValue.name == newValue.name &&
                            oldValue.style == newValue.style
                        ) {
                            //if only a name change, no need to reload
                            this.loadData();
                        }
                    }
                },
                true
            );

            $scope.$watch(
                () => this.filter,
                (newValue, oldValue) => {
                    if (oldValue && newValue !== oldValue) {
                        this.loadData();
                    }
                },
                true
            );
        }

        $onInit(): void {
            this.loadData();
        }

        loadData(): void {
            this.loading = true;
            this.dataProvider.statsData(this.widget, this.filter).then(
                (data: any): void => {
                    this.data = data;
                    this.loading = false;
                },
                (error: any): void => {
                    this.data = null;
                    this.loading = false;
                }
            );
        }
    },
};

angular
    .module("result")
    .component(DataStatsComponent.selector, DataStatsComponent);
